import { INIT_APP, INIT_APP_SUCCESS, INIT_APP_ERROR } from './types';

export const initialState = {
	initializing: false,
	isInitialized: false,
};

function initApp(state = initialState, action) {
	switch (action.type) {
		case INIT_APP:
			return {
				...state,
				initializing: true,
				isInitialized: false,
			};
		case INIT_APP_SUCCESS:
			return {
				...state,
				initializing: false,
				isInitialized: true,
			};
		case INIT_APP_ERROR:
			return {
				...state,
				initializing: false,
				isInitialized: false,
			};
		default:
			return state;
	}
}

export default initApp;
